export const GTM_CONTAINER_ID = process.env.GTM_CONTAINER_ID;
